import React, { Component } from 'react';
import yaml from 'js-yaml';
import '../css/AnnouncementBanner.css';

class AnnouncementBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      dismissed: false,
      content: null,
      link: null
    }
  }

  componentDidMount() {
    // Check if user already dismissed
    if (sessionStorage.getItem('banner_dismissed') === 'true') {
      return;
    }

    fetch(process.env.PUBLIC_URL + '/yaml/announcement.yaml')
      .then(response => response.text())
      .then(text => {
        const data = yaml.load(text);
        if (data && data.active) {
          this.setState({
            active: true,
            content: data.content,
            link: data.link || null
          });
        }
      })
      .catch(() => {});
  }

  dismiss() {
    this.setState({ dismissed: true });
    sessionStorage.setItem('banner_dismissed', 'true');
  }

  render() {
    if (!this.state.active || this.state.dismissed || !this.state.content) return null;

    const lang = this.props.lang;
    const text = this.state.content[lang] || this.state.content['en'] || '';

    return (
      <div className="announcement_banner">
        <div className="announcement_content">
          {this.state.link ? (
            <a href={this.state.link} className="announcement_link">{text}</a>
          ) : (
            <span>{text}</span>
          )}
        </div>
        <button className="announcement_close" onClick={() => this.dismiss()}>&times;</button>
      </div>
    );
  }
}

export default AnnouncementBanner;
